import { Shipment } from "pwapi";

import { PWAction } from "shared/utils/redux";

import { SHIPMENTS } from "app/actions/shippingActions";

const shipmentsReducer = (
  state: Shipment[] = [],
  action: PWAction
): Shipment[] => {
  switch (action.type) {
    case SHIPMENTS.LIST.REQUEST:
      return [];
    case SHIPMENTS.LIST.SUCCESS:
      return action.payload.response.results;
    case SHIPMENTS.LIST.ERROR:
      return [];
  }

  return state;
};

export default shipmentsReducer;
